import { type Provider } from '../../../queries/schema/carFinance.schema';

const RESULT = {
  SUCCESS: 'success',
  FAILURE: 'failure',
} as const;

type Results = (typeof RESULT)[keyof typeof RESULT];

type ApplicationTrackingArgs = {
  result: Results;
  provider: Provider;
  errorFields?: Array<string>;
};

export { RESULT, type ApplicationTrackingArgs };
